import { render, staticRenderFns } from "./lists.vue?vue&type=template&id=4c689728&scoped=true"
import script from "./lists.vue?vue&type=script&lang=js"
export * from "./lists.vue?vue&type=script&lang=js"
import style0 from "./lists.vue?vue&type=style&index=0&id=4c689728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c689728",
  null
  
)

export default component.exports